export function formatKoreanMobile(value: string) {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}

export function normalizeKoreanMobile(value: string | number): string | null {
  let digits = String(value).replace(/\D/g, "");
  if (digits.length === 10 && digits.startsWith("10")) digits = `0${digits}`;
  if (!/^010\d{8}$/.test(digits)) return null;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}

export function isKoreanMobile(value: string) {
  return /^010-\d{4}-\d{4}$/.test(formatKoreanMobile(value));
}
